import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 25 24'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='m10.404 6.346 1.054 1.084-3.82 3.82H19.75v1.5H7.639l3.819 3.819-1.054 1.084L4.75 12z'
    />
  </svg>
)
export default SvgComponent
